/**
 * @generated SignedSource<<99b0770f241fa9856957906e9a44d75d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsSeller_item$data = {
  readonly seller: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller" | "PdpSharedDealerDetailsFeedback_seller" | "SharedStarRating_seller" | "usePdpSellerDetails_seller">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCallDealerCta_item">;
  readonly " $fragmentType": "PdpRespSidebarDetailsSeller_item";
};
export type PdpRespSidebarDetailsSeller_item$key = {
  readonly " $data"?: PdpRespSidebarDetailsSeller_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsSeller_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsSeller_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "usePdpSellerDetails_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedStarRating_seller"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDetailsFeedback_seller"
        },
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "isExtended",
                  "value": true
                }
              ],
              "kind": "FragmentSpread",
              "name": "PdpSharedDealerDetailsBioModalLazy_seller"
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1c12570890d10c49f24b07905c1eb582";

export default node;
